require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-climate-investment-funds-2-0-how-can-it-be-additiv.json") })
        }
      }, "path---en-us-update-climate-investment-funds-2-0-how-can-it-be-additiv");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-climate-investment-funds-2-0-how-can-it-be-additiv!./.cache/json/en-us-update-climate-investment-funds-2-0-how-can-it-be-additiv.json
// module id = 643
// module chunks = 231608221292675